import { NpsInterface } from "../../models/nps.models";
import { StorageRequiredData } from "../storage-data";


export interface NpsState {
    nps: StorageRequiredData<NpsInterface[], any>;
    showNps: boolean;
}

export const INITIAL_STATE: NpsState = {
    nps: {
      data: [],
      loading: false,
      error: null,
    },
    showNps: false,
};

export enum NpsActionTypes {
    FETCH_NPS_DATA = "@nps/FETCH_NPS_DATA",
    FETCH_NPS_DATA_SUCCESS = "@nps/FETCH_NPS_DATA_SUCCESS",
    FETCH_NPS_DATA_ERROR = "@nps/FETCH_NPS_DATA_ERROR",

    SUBMIT_NPS_ANSWER = "@nps/SUBMIT_NPS_ANSWER",
    SUBMIT_NPS_ANSWER_SUCCESS = "@nps/SUBMIT_NPS_ANSWER_SUCCESS",
    SUBMIT_NPS_ANSWER_ERROR = "@nps/SUBMIT_NPS_ANSWER_ERROR",

    FETCH_SHOW_NPS = "@nps/FETCH_SHOW_NPS",
    FETCH_HIDE_NPS = "@nps/FETCH_HIDE_NPS",
}
